import usePaginatedData from './use-paginated-data';
import { transformNotificationItem } from 'api/transformers';
import { ApartmentListItemProps } from 'components/apartment-list-item';
import { TWallMaterial } from 'lib/types';

export type APINotificationItem = {
  notification: {
    id: number;
    isEnabled: boolean;
  };
  id: number;
  parameterCount: number;
  
  areaFrom?: number;
  areaTo?: number;
  pricePerSqMFrom?: number;
  pricePerSqMTo?: number;
  priceTo?: number;
  priceFrom?: number;
  bedroomCount?: number[];
  wallMaterials?: TWallMaterial[];
  facilityTypeIds?: number[]
  floors?: number[]
  floorCount?: number[];
  commissioningYears?:[]

  floor: number;
  roomCount: number;
  areaInSqM: number;
  planImage: string;
  apartmentComplexTitle: string;
  price: number;
  pricePerSqM: number;
  isFavorite: boolean;
  notificationEnabled: boolean;
  marketTypes?: string;
};

export type APIApartmentNotificationRes = {
  items: APINotificationItem[];
  count: number;
};

export type ApartmentNotification = Omit<ApartmentListItemProps, 'className' | 'icon'> & {
  id: number;
  notification: { id: number; isEnabled: boolean };
  marketTypes?: string;
};

const useApartmentNotification = () => {
  const result = usePaginatedData<APIApartmentNotificationRes, ApartmentNotification>(
    '/facility-notifications/search',
    'post',
    // @ts-ignore
    ({ items, count }) => {
      // @ts-ignore
      const notifications = items.map(transformNotificationItem);
      return { items: notifications, count };
    },
    {},
  );

  return result;
};

export default useApartmentNotification;
